import type { TailscaleConnectorHosting } from "@p0security/integrations-tailscale-shared/types";

// This copies Auth0's image pins (app#7529 @ 3c8d887b9a) instead of sharing
// them, so adding Tailscale changes no other integration.

/** A connector image on Docker Hub, pinned by the digest its tag resolves
 * to. */
export type ConnectorImage = Readonly<{
  /** `sha256:<digest>` */
  digest: string;
  name: string;
  tag: string;
}>;

/** The connector build each cloud deploys: one image for AWS Lambda and one
 * for Cloud Run, built from the same service.
 *
 * Each is a p0-security-perimeter build of the connector, by its
 * `sha-<commit>` tag on Docker Hub and the digest that tag resolves to
 * (`docker buildx imagetools inspect <name>:<tag>`). The service's source has
 * moved to `submodules/connector`, but these pins still name perimeter builds
 * until they're moved to that repo's images. */
export const CONNECTOR_IMAGES: Readonly<
  Record<TailscaleConnectorHosting["type"], ConnectorImage>
> = {
  aws: {
    digest:
      "sha256:072afd15933f4650d03f530b955b2bce9218bb38f5d04050ef4fbc5fda7f85a0",
    name: "p0security/p0-connector-tailscale",
    tag: "sha-19655ef",
  },
  gcp: {
    digest:
      "sha256:6f75ba4338bcc45fced7144fc49c10417d38ae02d02a146b18cd34e107590007",
    name: "p0security/p0-connector-tailscale-gcloud",
    tag: "sha-19655ef",
  },
};
